import {Modal, ModalContent} from '@hm/fundamental'

import {StepDrillingResultsDropzone} from './uploadSteps'

import type {
  DrillingPosition,
  ParsedDrillingData,
  ShutdownDrillingDTO
} from '@refra/modules/refra-planning/types'

interface UploadDrillingResultsDialogProps {
  isOpen: boolean
  closeDialog: () => void
  shutdownId: number
  shutdownName: string
  drillingPositions: DrillingPosition[]
  drillings: ShutdownDrillingDTO[]
  onDataImported: (data: ParsedDrillingData) => void
  kilnLength: number
}

export const UploadDrillingResultsDialog: React.FC<UploadDrillingResultsDialogProps> = ({
  isOpen,
  closeDialog,
  shutdownId,
  shutdownName,
  drillingPositions,
  drillings,
  onDataImported,
  kilnLength
}) => {
  const handleCancelUpload = () => {
    closeDialog()
  }

  const handleUploadComplete = (data: ParsedDrillingData) => {
    onDataImported(data)
    closeDialog()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleCancelUpload}
      isExitEnabled={false}
      data-cy="upload_drilling_results_dialog"
      width="wide"
    >
      <ModalContent>
        <div onClick={(e) => e.stopPropagation()} onMouseDown={(e) => e.stopPropagation()}>
          <StepDrillingResultsDropzone
            cancelUpload={handleCancelUpload}
            onDataImported={handleUploadComplete}
            shutdownId={shutdownId}
            shutdownName={shutdownName}
            drillingPositions={drillingPositions}
            drillings={drillings}
            kilnLength={kilnLength}
          />
        </div>
      </ModalContent>
    </Modal>
  )
}
